import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

function BankDetailsForm() {
  const [open, setOpen] = React.useState(false);

  const Navigate = useNavigate();

  const handleClickOpen = () => {
    setOpen(true);
    Navigate("/admin-page/student");
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [formData, setFormData] = useState({
    bankName: "",
    accountName: "",
    accountNumber: "",
    bvn: "",
  });

  const handleInputChange = (field) => (e) => {
    setFormData({ ...formData, [field]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Check for empty fields
    const isEmptyField = Object.values(formData).some((value) => value === "");

    if (isEmptyField) {
      alert("Please fill out all fields");
    } else {
      // Submit the form (you can implement your submission logic here)

      console.log("data");

      //  console.log("Form submitted:", );
      setFormData({
        bankName: "",
        accountName: "",
        accountNumber: "",
        bvn: "",
      });
    }
  };
  return (
    <div className="h-fit">
      <form onSubmit={handleSubmit}>
        <TextField
          label="Bank Name"
          variant="outlined"
          fullWidth
          margin="normal"
          value={formData.bankName}
          onChange={handleInputChange("bankName")}
        />
        <TextField
          label="Account Name"
          variant="outlined"
          fullWidth
          margin="normal"
          value={formData.accountName}
          onChange={handleInputChange("accountName")}
        />
        <TextField
          label="Account Number"
          type="tel"
          variant="outlined"
          fullWidth
          margin="normal"
          value={formData.accountNumber}
          onChange={handleInputChange("accountNumber")}
        />
        <TextField
          label="BVN"
          type="tel"
          variant="outlined"
          fullWidth
          margin="normal"
          value={formData.bvn}
          onChange={handleInputChange("bvn")}
        />

        <Button type="submit" variant="contained" color="primary">
          Add
        </Button>
      </form>
    </div>
  );
}

export default BankDetailsForm;
